import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Moment from 'react-moment';

import Loading from '../components/Loading';
import API from '../api/ApiTool';

const styles = {
  actions: {
    cursor: 'pointer',
    marginTop: '12px',
    color: '#3b82f6'
  },
};

function dynamicSort(property) {
  var sortOrder = 1;
  if(property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
  }
  return function (a, b) {
    if (property === 'past_due_datetime') {
      const dateA = new Date(a[property]);
      const dateB = new Date(b[property]);

      var resultOfDates = (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;
      return resultOfDates * sortOrder;
    }

    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    return result * sortOrder;
  }
}

const InvoicesTable = (props) => {
  return (
    <div>
      <Table style={{backgroundColor: "#0f172a"}}>
        <TableHead>
          <TableRow>
            <TableCell>
              {'Stripe Invoice ID'}
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'company_name'}
                direction={props.getDirection('company_name')}
                onClick={() => props.handleSort('company_name')}
              >
                Company
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'past_due_datetime'}
                direction={props.getDirection('past_due_datetime')}
                onClick={() => props.handleSort('past_due_datetime')}
              >
                {'Date of Delinquency'}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              {'Stripe ID'}
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'plan'}
                direction={props.getDirection('plan')}
                onClick={() => props.handleSort('plan')}
              >
                {'Plan'}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'lock_delinquent'}
                direction={props.getDirection('lock_delinquent')}
                onClick={() => props.handleSort('lock_delinquent')}
              >
                {'Delinquent Flag'}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'amount_due'}
                direction={props.getDirection('amount_due')}
                onClick={() => props.handleSort('amount_due')}
              >
                {'Amount Delinquent'}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={props.property === 'billing_type'}
                direction={props.getDirection('billing_type')}
                onClick={() => props.handleSort('billing_type')}
              >
                {'Billing Method'}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.invoices.map((invoice, i) => {
            return (
              <TableRow
                key={i}
              >
                <TableCell>{invoice.invoice_number}</TableCell>
                <TableCell
                    style={styles.actions}
                    onClick={() => props.companyDetail(invoice.company_id, props.push)}
                  >
                    {invoice.company_name}
                </TableCell>
                <TableCell>
                  <Moment format="YYYY/MM/DD">
                    {invoice.past_due_datetime}
                  </Moment>
                </TableCell>
                <TableCell>{invoice.customer_id}</TableCell>
                <TableCell padding={'none'}>{invoice.plan}</TableCell>
                <TableCell>{invoice.lock_delinquent ? 'True' : 'False'}</TableCell>
                <TableCell>{invoice.amount_due}</TableCell>
                <TableCell>{invoice.billing_type}</TableCell>
                <TableCell padding={'none'}>
                  {!invoice.lock_delinquent ?
                    <p
                      style={styles.actions}
                      onClick={()=> props.companySetDelinquent(invoice.company_id)}
                    >{`Set Delinquent Flag`}
                    </p>
                  :
                    undefined
                  }
                  <p
                    style={styles.actions}
                    onClick={()=> window.open(
                      `http://` + window.location.hostname + `/bbladmin/accounts/company/${invoice.company_id}/`, '_blank'
                    )}
                  >{'See Company Record'}
                  </p>
                  <p
                    style={styles.actions}
                    onClick={()=> window.open(
                      `https://dashboard.stripe.com/customers/${invoice.customer_id}/`, '_blank'
                    )}
                  >{`See Stripe`}
                  </p>
                  <p
                    style={styles.actions}
                    onClick={()=> props.unsubscribeCustomer(invoice.company_id, invoice.company_name)}
                  >{`Unsubscribe Customer`}
                  </p>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};


class DelinquencyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
      property: 'company_name',
      order: 'asc',
      unsubscribeModal: false,
      unsubscribeCompanyName: '',
      unsubscribeCompanyID: '',
      unsubscribeReason: ''
    };
  }

  fetchData() {
    const property = this.state.property;

    this.setState({ loading: true });

    API.GET(`/accounts/past-due-invoices/`)
      .then(response => response.json())
      .then(data => this.setState({ data: data.invoices.sort(dynamicSort(property)) }))
      .then(() => this.setState({ loading: false }))
  }

  componentDidMount() {
    this.fetchData();
  }

  companyDetail(id, push) {
    push(`/company-detail/${id}`);
  }

  companySetDelinquent(id) {
    this.setState({ loading: true });

    API.POST(`/accounts/past-due-invoices/`, { 'id': id })      
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          this.fetchData();
        }
      })
  }

  unsubscribeCustomer(id, name) {
    this.setState({ unsubscribeModal: true });
    this.setState({ unsubscribeCompanyID: id });
    this.setState({ unsubscribeCompany: name });
  }

  handleCloseUnsubscribe() {
    this.setState({ unsubscribeModal: false });
  }

  handleSubmitUnsubscribe() {
    this.setState({ loading: true });
    API.POST(`/accounts/unsubscribe-customer/`, {
      'id': this.state.unsubscribeCompanyID,
      'reason': this.state.unsubscribeReason
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          this.setState({ unsubscribeModal: false });
          this.setState({ unsubscribeCompanyID: '' });
          this.setState({ unsubscribeCompany: '' });
          this.fetchData();
        }
      })
  }

  unsubscribeReason(text) {
    this.setState({ unsubscribeReason: text });
  }

  handleSort(property) {
    if (property === this.state.property && this.state.order === 'asc') {
      this.setState({ order: 'desc' }, () => {
        const data = this.state.data;
        const sortedData = data.sort(dynamicSort('-' + property));
        this.setState({ data: sortedData });
      });
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      this.setState({ order: 'asc' }, () => {
        const data = this.state.data;
        const sortedData = data.sort(dynamicSort(property));
        this.setState({ data: sortedData });
      });
    }
    else {
      this.setState({ property: property }, () => {
        this.setState({ order: 'asc' }, () => {
          const data = this.state.data;
          const sortedData = data.sort(dynamicSort(property));
          this.setState({ data: sortedData });
        });
      });
    }
  }

  getDirection(property) {
    let order = 'asc';
    if (property === this.state.property && this.state.order === 'asc') {
      order = 'asc';
    }
    else if (property === this.state.property && this.state.order === 'desc') {
      order = 'desc';
    }
    return order;
  }

  render() {
    const { data, loading } = this.state;

    if (loading) {
      return (
        <Loading />
      );
    }

    return (
      <div>
        <Dialog
          open={this.state.unsubscribeModal}
          onClose={this.handleCloseUnsubscribe.bind(this)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">{`Unsubscribe ${this.state.unsubscribeCompany}`}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              To unsubscribe this customer, please specify the reason for cancellation.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="reason"
              label="Reason for cancellation"
              type="text"
              fullWidth
              onChange={event => this.unsubscribeReason(event.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseUnsubscribe.bind(this)} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSubmitUnsubscribe.bind(this)} color="primary">
              Unsubscribe
            </Button>
          </DialogActions>
        </Dialog>
        <InvoicesTable
          data={data}
          push={this.props.history.push}
          companyDetail={this.companyDetail.bind(this)}
          companySetDelinquent={this.companySetDelinquent.bind(this)}
          invoices={data}
          handleSort={this.handleSort.bind(this)}
          getDirection={this.getDirection.bind(this)}
          unsubscribeCustomer={this.unsubscribeCustomer.bind(this)}
          property={this.state.property}
        />
      </div>
    );
  }
}

export default withRouter(DelinquencyReport);



// WEBPACK FOOTER //
// ./src/pages/DelinquencyReport.js